import { useScrollReveal } from '../hooks/useScrollReveal';
import { MapPin, Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export const FounderSection = () => {
  const [ref, isVisible] = useScrollReveal();
  const { t } = useLanguage();
  const founderImage = '/images/founder.jpg';

  return (
    <section id="founder" className="relative py-28 bg-[#0E0E0E] overflow-hidden" ref={ref}>
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className={`lg:col-span-2 transition-all duration-1000 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}>
            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border border-[#C9A84C]/15">
                <img src={founderImage} alt={t.founder.name} className="w-full aspect-[3/4] object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0E0E0E]/40 via-transparent to-transparent" />
              </div>
              <div className="absolute bottom-4 left-4 right-4 p-4 bg-[#0A0A0A]/80 backdrop-blur-md rounded-xl border border-[#C9A84C]/15">
                <p className="text-[#F5F0E8] font-semibold text-base">{t.founder.name}</p>
                <p className="text-[#C9A84C] text-sm">{t.founder.role}</p>
                <div className="flex items-center gap-1.5 mt-1"><MapPin size={12} className="text-[#8A8680]" /><span className="text-[#8A8680] text-xs">{t.founder.location}</span></div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-3">
            <div className={`flex items-center gap-3 mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <div className="h-[1px] w-8 bg-[#C9A84C]" />
              <span className="text-[#C9A84C] text-sm font-medium tracking-[0.2em] uppercase">{t.founder.tag}</span>
            </div>
            <h2 className={`text-4xl sm:text-5xl font-bold text-[#F5F0E8] mb-8 font-heading transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>{t.founder.headline}<br /><span className="text-[#C9A84C]">{t.founder.headlineAccent}</span></h2>
            <div className={`text-[#9A9590] text-lg leading-relaxed mb-10 transition-all duration-700 delay-200 space-y-5 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              {t.founder.bio.split('\n').map((p, i) => <p key={i}>{p}</p>)}
            </div>
            <div className={`relative p-6 bg-[#161616] border border-[#C9A84C]/15 rounded-xl transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <Quote className="text-[#C9A84C]/30 absolute top-4 right-4" size={32} />
              <p className="text-[#F5F0E8]/80 italic text-base leading-relaxed pr-10">"{t.founder.quote}"</p>
              <div className="mt-4 flex items-center gap-3"><div className="h-[1px] w-6 bg-[#C9A84C]/40" /><span className="text-[#C9A84C] text-sm font-medium">{t.founder.name}</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
